<template>
    <header class="header">
        <div class="header__inner">
            <div class="header__menu-wrap">
                <div class="header__logo">
                    <router-link to="/" @click="activeFn($event)">
                        <img src="../../assets/resource/icon/logo.svg" alt="오상테크놀로지 로고" title="메인으로 이동">
                    </router-link>
                </div>

                <div class="header__menu">
                    <ul class="header__menu-list">
                        <li class="header__menu-item" :class="{ active: menuActive === 'Company Introduction' }">
                            <router-link to="/Introduction" class="header__menu-link" @click="activeFn($event)" title="Company Introduction">Company Introduction</router-link>
                        </li>
                        <li class="header__menu-item" :class="{ active: menuActive === 'O2O Service' }">
                            <router-link to="/Service" class="header__menu-link" @click="activeFn($event)" title="O2O Service">O2O Service</router-link>
                        </li>
                        <li class="header__menu-item" :class="{ active: menuActive === 'Portfolio' }">
                            <router-link to="/Portfolio" class="header__menu-link" @click="activeFn($event)" title="Portfolio">Portfolio</router-link>
                        </li>
                        <li class="header__menu-item" :class="{ active: menuActive === 'Customer Support' }">
                            <router-link to="/CustomerSupport" class="header__menu-link" @click="activeFn($event)" title="Customer Support">Customer Support</router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="site-map__inner">

                <div class="header__btn">
                    <!-- <router-link :to="{ path: '/CustomerSupport', query: { name: 'inquiry' } }" class="header__btn-link">
                    <span>Business Inquiry</span>
                    <span><img src="../../assets/resource/icon/send_fill.png" alt=""></span>
                </router-link> -->
                    <div class="header__btn-inner">
                        <div class="btn__toggle btn__language" :class="{active: this.btnLink === 'language'}" @click="this.btnLink = 'language'">
                            <div id="google_translate_element" class="goole__select mo-none"></div>
                            <span class="name">Translation
                                <div class="google_translate__wrap">
                                    <div id="google_translate_element2" class="pc-none"></div>
                                </div>
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                <path
                                    d="M21.633 13.0855C21.2329 15.118 20.2592 16.9934 18.8271 18.4901C17.3949 19.9867 15.5642 21.042 13.5513 21.5312C14.1038 20.879 14.5826 20.034 14.9802 19.0752C15.3756 18.1219 15.706 17.0158 15.9509 15.8036C17.7676 15.3356 19.4132 14.6162 20.7934 13.6965C21.0837 13.5026 21.3643 13.2989 21.633 13.0855ZM0.367121 13.0855C0.635788 13.2989 0.916371 13.5026 1.2067 13.6965C2.58579 14.6162 4.23137 15.3356 6.0492 15.8036C6.29295 17.0158 6.62337 18.1219 7.01987 19.0752C7.41637 20.0329 7.8952 20.879 8.4477 21.5312C6.43501 21.0418 4.6045 19.9864 3.17255 18.4898C1.74061 16.9932 0.767105 15.1178 0.367121 13.0855ZM13.6293 16.2488C13.4606 16.9295 13.243 17.5971 12.9782 18.2465C12.6023 19.1543 12.1885 19.8227 11.7963 20.2463C11.3955 20.6797 11.1203 20.7501 11 20.7501C10.8798 20.7501 10.6057 20.6797 10.2038 20.2463C9.81162 19.8238 9.39779 19.1543 9.02187 18.2465C8.75705 17.5971 8.53946 16.9295 8.37079 16.2488C9.22445 16.3593 10.1041 16.4167 11 16.4167C11.8792 16.4173 12.7574 16.3612 13.6293 16.2488ZM14.21 9.62316C14.2947 11.0819 14.2432 12.5453 14.0561 13.9944C13.0844 14.1612 12.0595 14.2501 11 14.2501C9.97559 14.2513 8.95289 14.1657 7.94287 13.9944C7.75309 12.5455 7.70194 11.0818 7.79012 9.62316C8.81495 9.81491 9.89179 9.91674 11 9.91674C12.0768 9.91793 13.1513 9.81965 14.21 9.62316ZM20.8215 6.42299C21.3199 7.49116 21.6503 8.65466 21.7749 9.87774C21.2321 10.6068 20.4998 11.2882 19.5909 11.8927C18.6484 12.5211 17.5369 13.0519 16.2986 13.4495C16.4399 11.9928 16.4552 10.5267 16.3441 9.06741C17.3669 8.72742 18.3433 8.26124 19.2507 7.67966C19.8156 7.31515 20.3419 6.89409 20.8215 6.42299ZM1.17854 6.42299C1.64437 6.88558 2.1752 7.30591 2.74937 7.67966C3.65669 8.26144 4.6331 8.72762 5.65595 9.06741C5.54527 10.5267 5.56013 11.9928 5.70037 13.4495C4.46212 13.0519 3.35062 12.5222 2.40812 11.8938C1.50029 11.2882 0.767954 10.6068 0.224121 9.87774C0.349788 8.65358 0.679121 7.49116 1.17745 6.42191L1.17854 6.42299ZM11 1.25008C11.1192 1.25008 11.3944 1.32158 11.7963 1.75491C12.1885 2.17741 12.6023 2.84691 12.9782 3.75474C13.4007 4.77633 13.7517 6.03841 13.977 7.46083C13.0432 7.64824 12.0433 7.75008 11 7.75008C10.0002 7.75199 9.0027 7.6551 8.02195 7.46083C8.24729 6.03841 8.59829 4.77633 9.02187 3.75583C9.39779 2.84691 9.81162 2.17849 10.2027 1.75491C10.6057 1.32158 10.8798 1.25008 11 1.25008ZM13.5513 0.468994C15.9928 1.06197 18.1525 2.48456 19.6613 4.49358C19.1998 5.02452 18.6637 5.48576 18.0699 5.86291C17.442 6.266 16.7731 6.60119 16.0744 6.86283C15.8241 5.38841 15.446 4.05158 14.9802 2.92599C14.5826 1.96724 14.1049 1.12116 13.5513 0.468994ZM8.44879 0.468994C7.89629 1.12116 7.41745 1.96724 7.01987 2.92599C6.55404 4.05266 6.17487 5.38841 5.9257 6.86283C5.22697 6.6012 4.55805 6.26601 3.9302 5.86291C3.336 5.4858 2.79959 5.02456 2.3377 4.49358C3.84674 2.48435 6.00689 1.06174 8.44879 0.468994Z"
                                    fill="#888888" />
                            </svg>
                        </div>

                        <div class="btn__toggle btn__link " :class="{active: this.btnLink === 'link'}" @click="this.btnLink = 'link'">
                            <div class="name">Business Inquiry
                                <div class="link__move">
                                    <router-link :to="{ path: '/CustomerSupport', query: { name: 'inquiry' } }"></router-link>
                                </div>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <g clip-path="url(#clip0_421_3014)">
                                    <path
                                        d="M20.235 5.68597C20.667 4.49097 19.509 3.33297 18.314 3.76597L3.70904 9.04797C2.51004 9.48197 2.36504 11.118 3.46804 11.757L8.13004 14.456L12.293 10.293C12.4816 10.1108 12.7342 10.01 12.9964 10.0123C13.2586 10.0146 13.5095 10.1197 13.6949 10.3051C13.8803 10.4906 13.9854 10.7414 13.9877 11.0036C13.99 11.2658 13.8892 11.5184 13.707 11.707L9.54404 15.87L12.244 20.532C12.882 21.635 14.518 21.489 14.952 20.291L20.235 5.68597Z"
                                        fill="#888888" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_421_3014">
                                        <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="header__menu-btn" @click="siteMap = !siteMap">
                    <button type="button" class="menu-btn">
                        <img src="../../assets/resource/icon/menu-btn.png" alt="">
                    </button>
                </div>
            </div>
        </div>
        <div class="site-map" :class="{ active: siteMap }">
            <button type="button" class="site-map__close" @click="siteMap = !siteMap">
                <img src="../../assets/resource/icon/close.png" alt="">
            </button>
            <ul class="site-map__list">
                <li class="site-map__item" :class="{ active: menuActive === 'Company Introduction' }">
                    <router-link to="/Introduction" class="site-map-link" @click="activeFn($event), siteMap = !siteMap" title="Company Introduction">Company Introduction</router-link>
                </li>
                <li class="site-map__item" :class="{ active: menuActive === 'O2O Service' }">
                    <router-link to="/Service" class="site-map-link" @click="activeFn($event), siteMap = !siteMap" title="O2O Service">O2O Service</router-link>
                </li>
                <li class="site-map__item" :class="{ active: menuActive === 'Portfolio' }">
                    <router-link to="/Portfolio" class="site-map-link" @click="activeFn($event), siteMap = !siteMap" title="Portfolio">Portfolio</router-link>
                </li>
                <li class="site-map__item" :class="{ active: menuActive === 'Customer Support' }">
                    <router-link to="/CustomerSupport" class="site-map-link" @click="activeFn($event), siteMap = !siteMap" title="Customer Support">Customer Support</router-link>
                </li>
            </ul>
        </div>
    </header>
</template>

<script>
    export default {
        data() {
            return {
                menuActive: '',
                siteMap: false,
                btnLink: 'link'
            }
        },
        created() {
            this.loadGoogleTranslate()
        },
        mounted() {
            //this.googleTranslateElementInit();
        },
        methods: {
            activeFn(event) {
                this.menuActive = event.target.title
            },
            loadGoogleTranslate() {
                //console.log('loadGoogleTranslate 호출')
                const googleTranslateScript = document.createElement('script');
                googleTranslateScript.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
                googleTranslateScript.async = true; // 비동기 로드 설정
                document.body.appendChild(googleTranslateScript);
            },
            // googleTranslateElementInit(){
            //     console.log('googleTranslateElementInit 호출')
            //     new google.translate.TranslateElement({
            //         pageLanguage: 'en', // 기본 언어 설정
            //         includedLanguages: 'ko,en,ja,zh-CN,ru', // 지원하는 언어 설정
            //         layout: google.translate.TranslateElement.InlineLayout.SIMPLE
            //     }, 'google_translate_element');
            // }
        },
        watch: {
            '$route'(newQuery) {
                if (newQuery.name.includes('Introduction')) {
                    this.menuActive = 'Company Introduction';
                }
                if (newQuery.name.includes('Service')) {
                    this.menuActive = 'O2O Service';
                }
                if (newQuery.name.includes('CustomerSupport')) {
                    this.menuActive = 'Customer Support';
                }
            }
        },
    }

    const width = window.matchMedia(`(min-width: 721px)`) //윈도우 사이즈
    if (width.matches == true) {
        window.googleTranslateElementInit = function () {
            if (typeof google !== 'undefined' && google.translate) {
                new google.translate.TranslateElement({
                    pageLanguage: 'en', // 기본 언어를 영어로 설정
                    includedLanguages: 'en,ko,ja,zh-CN,ru', // 지원하는 언어 설정
                    layout: google.translate.TranslateElement.InlineLayout.VERTICAL
                }, 'google_translate_element');
            } else {
                console.error('Google Translate API is not loaded yet.');
            }
        };
    } else {
        window.googleTranslateElementInit = function () {
            if (typeof google !== 'undefined' && google.translate) {
                new google.translate.TranslateElement({
                    pageLanguage: 'en', // 기본 언어를 영어로 설정
                    includedLanguages: 'en,ko,ja,zh-CN,ru', // 지원하는 언어 설정
                    layout: google.translate.TranslateElement.InlineLayout.VERTICAL
                }, 'google_translate_element2');
            } else {
                console.error('Google Translate API is not loaded yet.');
            }
        };
    }

</script>